import assetPath from '/app/packages/lebenslauf/constants/src/assets/template-7.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')